"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _UserContext = _interopRequireDefault(require("@micado-digital/react-ui/context/UserContext"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));
var _fireCustomEvent = _interopRequireDefault(require("@micado-digital/react-ui/utils/fireCustomEvent"));
var _CartContext = _interopRequireDefault(require("../../context/CartContext"));
var _MessageContext = _interopRequireDefault(require("../../context/MessageContext"));
var _loginToShop = _interopRequireDefault(require("../../utils/login/loginToShop"));
var _updateGuestState = _interopRequireWildcard(require("../../utils/cart/updateGuestState"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
var _Login = _interopRequireDefault(require("../../components/Login"));
var _Register = _interopRequireDefault(require("../../components/Register"));
var _Login2 = _interopRequireDefault(require("./Login01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Login01 = _ref => {
  var _systemLink, _systemLink2;
  let {
    defaultLang = "de"
  } = _ref;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang: pageDataLang
  } = pageData || {};
  const {
    setCart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    setMessageObj
  } = (0, _react.useContext)(_MessageContext.default);
  const {
    pathname
  } = (0, _reactRouterDom.useLocation)();
  const [lang, setLang] = (0, _react.useState)(defaultLang);
  const [links, setLinks] = (0, _react.useState)(null);
  const setUserData = (0, _react.useContext)(_UserContext.default)[1];
  const navigate = (0, _useLink.default)();
  const systemLink = (0, _useSystemLinks.default)();
  const css = (0, _Login2.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const dashboardUrl = (_systemLink = systemLink("shop-myaccount")) !== null && _systemLink !== void 0 ? _systemLink : "/";
  const loginUrl = (_systemLink2 = systemLink("login")) !== null && _systemLink2 !== void 0 ? _systemLink2 : "/";
  (0, _react.useEffect)(() => {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  (0, _react.useEffect)(() => {
    setLinks(new Date().getTime());
  }, [dashboardUrl, loginUrl]);
  const handleLoginSuccess = (0, _react.useCallback)(async () => {
    const cartGUID = localStorage.getItem("mco-shop-cart-guid");
    const shopUserData = await (0, _loginToShop.default)();
    const {
      groups,
      msg
    } = shopUserData || {};
    if (msg) return;
    if (groups) {
      localStorage.setItem("mco-shop-user-groups", JSON.stringify(shopUserData === null || shopUserData === void 0 ? void 0 : shopUserData.groups));
    }
    if (cartGUID) {
      const response = await (0, _updateGuestState.default)(false);
      const {
        msg
      } = response || {};
      if (msg) {
        setMessageObj({
          message: l("reactShop.messages.errors.".concat(_updateGuestState.UPDATE_GUEST_STATE_ERRORS[msg])),
          type: "error"
        });
      } else {
        localStorage.setItem("mco-shop-cart", JSON.stringify(response));
        setUserData(prevUserData => ({
          ...shopUserData,
          ...prevUserData
        }));
        setCart(response);
      }
    }
    setUserData(prevUserData => ({
      ...shopUserData,
      ...prevUserData
    }));
    (0, _fireCustomEvent.default)("login", {
      method: "Default"
    });
    if (loginUrl === pathname) {
      setTimeout(() => {
        navigate(dashboardUrl);
      }, 2000);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardUrl, loginUrl]);
  return /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.login, "mco-shop-login"),
    key: links,
    maxWidth: "lg"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.wrapper
  }, /*#__PURE__*/_react.default.createElement(_Login.default, {
    lang: lang,
    onSuccess: handleLoginSuccess
  }), /*#__PURE__*/_react.default.createElement(_Register.default, {
    lang: lang
  })));
};
Login01.propTypes = {
  defaultLang: _propTypes.default.string
};
var _default = exports.default = Login01;